import React, { Component } from 'react'
import { Box } from '@material-ui/core'
// import ReachingOut from '../commonComponents/ReachingOut';
// import Companies from '../commonComponents/Companies';
// import ClientCarousel from '../commonComponents/ClientCarousel';
import ContactRegForm from './ContactRegForm';
import SecondHerosection from '../commonComponents/SecondHerosection';

interface Props {
    // classes: any,
}

class Contact extends Component<Props> {
    render() {
        return (
            <Box id="top">
                <SecondHerosection
                    heading="Contact"
                    // cardClass={5}
                    cardClass={"SecondHerosection-secondHerosectionHideCards"}
                    highlight={null}
                    secondHerosectionTitleClassName={"SecondHerosection-secondHerosectionSecondTitle"}
                    secondHerosectionClassName={"SecondHerosection-secondHerosectionSecondMessage"}
                    // secondHerosectionMessage={"We'd happy to hear from you!"}
                    secondHerosectionMessage={"For More Information About Our Courses, Get In Touch"}
                    secondHerosectionBody={"SecondHerosection-secondHerosectionBodySecond"}
                    secondHerosectionUnderlined={"SecondHerosection-secondHerosectionFourthUnderlined"}
                />
                <ContactRegForm />
                {/* <ClientCarousel /> */}
                {/* <Companies /> */}
                {/* <ReachingOut /> */}
            </Box>
        )
    }
}

export default Contact;